<template>
  <a-descriptions v-bind="descriptionsElAttrs" class="description">
    <template slot="label">
      <slot name="title"></slot>
    </template>
    <template slot="extra">
      <slot name="extra"></slot>
    </template>

    <template v-for="item in option">
      <a-descriptions-item
        v-if="showItem(item)"
        :key="item.label"
        :label="item.label"
        v-bind="item.elAttrs"
      >
        <slot
          v-if="item.slotName"
          :name="item.slotName"
          :option="item"
          :value="info[item.prop]"
        ></slot>
        <el-tag
          v-else-if="item.useTag"
          :type="tagType(item)"
          :size="
            item.tagAttrs && item.tagAttrs.size ? item.tagAttrs.size : 'small'
          "
          v-bind="item.tagAttrs"
        >
          {{ content(item) }}
        </el-tag>
        <span v-else>{{ content(item) }}</span>
      </a-descriptions-item>
    </template>
  </a-descriptions>
</template>

<script>
import { isFunction } from 'element-ui/src/utils/types'
import { getPropByPath } from '@/utils/utils'

export default {
  name: 'AntDescriptions',

  props: {
    // element原生属性
    elAttrs: {
      type: Object,
      default: () => {}
    },

    info: {
      type: Object,
      default: () => {}
    },

    option: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      defaultElAttrs: {
        size: 'default',
        labelStyle: { whiteSpace: 'nowrap' },
        contentStyle: { marginRight: '10px' }
      }
    }
  },

  computed: {
    descriptionsElAttrs() {
      return Object.assign(this.defaultElAttrs, this.elAttrs)
    },

    content() {
      return option => {
        const TEMP_VALUE = option.prop
          ? getPropByPath(this.info, option.prop)
          : this.info
        // 优先执行filter过滤函数
        if (isFunction(option.filter)) {
          return option.filter(TEMP_VALUE)
        }
        if (!option.prop) {
          return this.info
        }
        // 如果有使用字典，则根据字典进行翻译
        if (option.dictArray) {
          const IS_DICT_OBJECT = (option.dictArray || []).every(item => {
            return this.isNotEmpty(item?.value) && this.isNotEmpty(item?.label)
          })
          if (!IS_DICT_OBJECT) {
            return '字典格式错误'
          }
          const TEMP_DICT_ITEM = (option.dictArray || []).find(
            item => item.value == TEMP_VALUE
          )
          return TEMP_DICT_ITEM?.label
        }
        return TEMP_VALUE || '-'
      }
    },

    tagType() {
      return option => {
        if (option.dictArray) {
          const TEMP_VALUE = this.info[option.prop]
          const TEMP_DICT_ITEM = (option.dictArray || []).find(
            item => item?.value == TEMP_VALUE
          )
          return TEMP_DICT_ITEM?.type || 'primary'
        } else {
          return 'primary'
        }
      }
    },

    showItem() {
      return option => {
        if (isFunction(option.hideFun)) {
          return !option.hideFun(this.info)
        } else {
          return true
        }
      }
    }
  },

  methods: {
    isNotEmpty(value) {
      return value !== undefined && value !== '' && value !== null
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .ant-descriptions-row,
  .ant-descriptions-item-content {
    vertical-align: top;
  }

  .ant-descriptions-row > th,
  .ant-descriptions-row > td {
    padding-bottom: 12px;
  }
}
</style>
